import {createContext, useEffect, useState} from "react";
import filterResponse from "../filterResponse";

export const authContext = createContext({
    user: {},
    setUser: (user) => {}
});

export function AuthProvider({children}) {
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const response = await fetch(`${process.env.REACT_APP_ENDPOINT}/user`, {
                    credentials: "include"
                });
                await filterResponse(response);

                if (response.status !== 200) {
                    setUser(null);
                }
                else {
                    const u = await response.json();
                    setUser(u);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <authContext.Provider value={{
            loading,
            user,
            setUser
        }}>
            {children}
        </authContext.Provider>
    );
}
